module.exports = __webpack_public_path__ + "static/hodiny-c61118a49e4b3165cbc37d52de0c2afd.jpg";